import React, { useState, useCallback } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Snackbar,
  Alert
} from "@mui/material";
import { useDropzone } from "react-dropzone";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useLocation } from "react-router-dom";
import { vendorApi } from "../../api/api";
import GradientButton from "../common/GradiantButton";

const documentTypes = [
  { label: "EC", value: "EC" },
  { label: "Patta", value: "Patta" },
  { label: "Other", value: "Other" },
];

const AddProjectDocuments = () => {
  const location = useLocation();
  const { data } = location.state;
  const [docType, setDocType] = useState("");
  const [docName, setDocName] = useState("");
  const [file, setFile] = useState(null);
  const [loading,setLoading]=useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const onDrop = useCallback((acceptedFiles) => {
    const pdf = acceptedFiles.find((file) => file.type === "application/pdf");
    if (pdf) setFile(pdf);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "application/pdf": [".pdf"] },
    multiple: true,
  });

  const handleUpload = async () => {
  if (!docType || !docName || !file) {
    alert("Please select type, name and upload a PDF file.");
    return;
  }
  setLoading(true);

 const formData = new FormData();
  formData.append("projectId", data?.id);
  // Documents[] must be a JSON string just like Postman
  const docPayload = {
    docName:docName,
    docType: docType,
    docOrder: 1, // Or dynamically assigned
    isAdditionalDocument: false,
  };
  formData.append("Documents[]", JSON.stringify(docPayload));
  formData.append("DocumentType[]",docType);
  formData.append("DocumentName[]",docName);
  formData.append("file[0]", file);

  try {
    const response = await vendorApi.addProjectDocuments(formData);
     setSnackbar({
        open: true,
        message: "Document uploaded successfully!",
        severity: "success",
      });
    setDocType("");
    setDocName("");
    setFile(null);
  } catch (error) {
    console.error("Upload failed:", error);
     const errorMsg =
      error.response?.data?.message || error.message || "Upload failed";
    setSnackbar({
      open: true,
      message: errorMsg,
      severity: "error",
    });
  }
  finally{
    setLoading(false);
  }
};


  return (
    <Box sx={{ maxWidth: {lg:"50vw",xs:"80vw"}, margin: "auto", mt: 4 ,height:"80vh" ,padding:3}}>
      <Typography variant="h6" gutterBottom sx={{paddingBottom:3}}>
        Add Document
      </Typography>

      <Stack spacing={4}>
        <TextField
          label="Document Type"
          select
          value={docType}
          onChange={(e) => setDocType(e.target.value)}
          fullWidth
        >
          {documentTypes.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          label="Document Name"
          value={docName}
          onChange={(e) => setDocName(e.target.value)}
          fullWidth
        />

        <Paper
          {...getRootProps()}
          sx={{
            p: 3,
            border: "2px dashed #90caf9",
            backgroundColor: isDragActive ? "#f0f8ff" : "#fafafa",
            cursor: "pointer",
            textAlign: "center",
          }}
        >
          <input {...getInputProps()} />
          <Typography>
            {isDragActive
              ? "Drop the PDF file here..."
              : "Drag & drop PDF here, or click to select"}
          </Typography>
          <Button variant="outlined" sx={{ mt: 1 }}>
            Select File
          </Button>
        </Paper>

        {file && (
          <List>
            <ListItem>
              <ListItemIcon>
                <PictureAsPdfIcon color="error" />
              </ListItemIcon>
              <ListItemText primary={file.name} />
            </ListItem>
          </List>
        )}
        <GradientButton
        text="Upload Document"
        onClick={handleUpload}
        width="100%"/>
      </Stack>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddProjectDocuments;
